<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      :finish-button-text="'Daftar List Sidang'"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        v-if="berkas.role != 'umum'"
        title="Jenis Sidang"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Jenis Sidang
              </h5>
              <small class="text-muted">
                Pilih Jenis Sidang Anda.
              </small>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group>
                <label for="">Jenjang <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jenjang"
                  rules="required"
                >
                  <v-select
                    id="jenjang"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jenjangOption.options"
                    v-model="berkas.jenjang_id"
                    placeholder="Pilih Jenjang"
                    @input="(val) => changeJenjang(val)"
                     :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Prodi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="prodi"
                  rules="required"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prodiOption.options"
                    v-model="berkas.prodi_id"
                    placeholder="Pilih prodi"
                     :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
       v-if="berkas.role != 'umum'"
        title="Form Pendaftaran"
        :before-change="validationFormPendaftaran"
      >
        <validation-observer
          ref="accountRulesPendaftaran"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Form Pendaftaran Ujian
              </h5>
              <small class="text-muted">
                Lengkapi form pendaftaran anda.
              </small>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group>
                <label for="">Jenjang <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jenjang"
                  rules="required"
                >
                  <v-select
                    id="jenjang"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jenjangOption.options"
                    v-model="berkas.jenjang_id"
                    placeholder="Pilih Jenjang"
                    @input="(val) => changeJenjang(val)"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Prodi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="prodi"
                  rules="required"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prodiOption.options"
                    v-model="berkas.prodi_id"
                    placeholder="Pilih prodi"
                     :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="berkas.jenjang_id == 'd7502c8f68d11921bdf217e8fd173a69'">
            <sarjana-form 
              :berkas="berkas"
              :masterData="masterData"
            />
          </div>
          <div v-if="berkas.jenjang_id == '4c9a8f414b8fcbab8c8a993d182ef72b'">
            <magister-form 
            :berkas="berkas"
            :masterData="masterData"
            />
          </div>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
       v-if="berkas.role != 'umum'"
        title="Berkas Sidang"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Sidang
              </h5>
              <small class="text-muted">Lengkapi Berkas Sidang Anda</small>
            </b-col>
          </b-row>
          <!-- Berkas Sidang -->
          <b-row v-for="item in berkas.berkas_pengajuan" :key="item.berkas_pengajuan_uuid" style="margin-bottom: 10px;">
            <b-col md="7">
              <b-form-group>
                <label for="">{{ item.title }} <span style="color: red; font-size: 16px;" v-if="item.is_required && !item.title.toLowerCase().includes('ringkas')">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  :name="item.title"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="item.file_input"
                    accept="application/pdf"
                    :disabled="true"
                  />
                  <b-button
                    v-if="item.file != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(item.file)"
                  >
                    Lihat
                  </b-button>
                  <b-button
                    :disabled="showSpinner == 1"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    class="mb-75 mr-75 ml-1"
                    @click="simpanBerkas()"
                    v-if="berkas.role == 'mahasiswa'"
                  >
                    Simpan
                  </b-button>
                  <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinner == 1"
                  ></b-spinner>
                  <div>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :variant="item.note == null ? 'outline-primary' : 'danger'"
                      class="mb-75 mr-75 ml-1"
                      @click="$bvModal.show(`bv-modal-note${item.berkas_pengajuan_uuid}`)"
                    >
                      Catatan
                    </b-button>
                    <b-modal :id="`bv-modal-note${item.berkas_pengajuan_uuid}`" hide-footer>
                      <template #modal-title>
                        Catatan Perbaikan Berkas
                      </template>
                      <div class="d-block text-center">
                        <b-form-textarea rows="5" placeholder="Catatan Perbaikan" v-model="item.note"></b-form-textarea>
                      </div>
                      <center>
                        <b-button class="mt-3 mr-1" variant="primary" @click="simpanNote(item.berkas_pengajuan_uuid, item.note)">Kirim</b-button>
                        <b-button class="mt-3" variant="danger" @click="$bvModal.hide(`bv-modal-note${item.berkas_pengajuan_uuid}`)">Tutup</b-button>
                      </center>>
                    </b-modal>
                  </div>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="5">
               <label for="">{{ item.description }}</label>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- View Admin -->
      <tab-content
        v-if="(berkas.role == 'admin' || berkas.role == 'superadmin')"
        title="Penetapan Jadwal Sidang"
        :before-change="validationFormAddress2"
      >
        <validation-observer
          ref="addressRules2"
          tag="form"
        >
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ruangan Terpakai
              </h5>
              <small class="text-muted">Daftar ruangan yang telah terpakai ujian</small>
            </b-col>
          </b-row>
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col md="12" class="mb-3" style="height: 200px;">
                <b-table hover :items="ruangan_terpakai" style="overflow: scroll;"></b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Ruangan Sidang"
                label-for="Ruangan Sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ruangan_sidang"
                  :rules="$can('set-ruangan-sidang','pengajuan-sidang') ? 'required' : ''"
                >
                  <v-select
                    id="ruangan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="ruanganOption.options"
                    v-model="jadwal_sidang.ruangan_id"
                    placeholder="Pilih Ruangan"
                    :disabled="!$can('set-ruangan-sidang','pengajuan-sidang')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Tanggal Ujian"
                label-for="Tanggal Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_ujian"
                  rules="required"
                >
                  <v-select
                    id="tanggal_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="tanggalUjianPenetapanOption.options"
                    v-model="jadwal_sidang.tanggal"
                    placeholder="Pilih Tanggal"
                    :disabled="!$can('manage','all-content') || berkas.is_ok_umum != null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Waktu Ujian"
                label-for="Waktu Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="waktu_ujian"
                  rules="required"
                >
                  <v-select
                    id="waktu_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="waktuUjianPenetapanOption.options"
                    v-model="jadwal_sidang.waktu_ujian_id"
                    placeholder="Pilih Waktu Ujian"
                    :disabled="!$can('manage','all-content') || berkas.is_ok_umum != null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        v-if="$can('dekanat', 'pengajuan-sidang')"
        title="Surat Tugas"
        :before-change="validationFormAddress3"
      >
        <validation-observer
          ref="addressRules3"
          tag="form"
        >
          <b-row v-if="$can('dekanat','pengajuan-sidang')">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Surat Tugas
              </h5>
              <small class="text-muted">Surat tugas untuk penguji</small>
            </b-col>
          </b-row>
          <!-- <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Nomor Surat Tugas Pembimbing"
                label-for="Nomor Surat Tugas Pembimbing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nomor Surat Tugas Pembimbing"
                  :rules="$can('dekanat','pengajuan-sidang') ? 'required' : ''"
                >
                  <b-form-input
                    id="nomor_surat"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Surat Tugas Pembimbing"
                    :disabled="!$can('dekanat','pengajuan-sidang')"
                    v-model="surat_tugas.nomor_surat_tugas_pembimbing"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Pembimbing"
                label-for="Pembimbing"
              >
                <b-table hover :items="tim_pembimbing" style="overflow: scroll;"></b-table>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Nomor Surat Tugas Penguji"
                label-for="Nomor Surat Tugas Penguji"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nomor Surat Tugas Penguji"
                  :rules="$can('dekanat','pengajuan-sidang') ? 'required' : ''"
                >
                  <b-form-input
                    id="nomor_surat"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Surat Tugas Penguji"
                    :disabled="!$can('dekanat','pengajuan-sidang')"
                    v-model="surat_tugas.nomor_surat_tugas_penguji"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Penguji"
                label-for="Penguji"
              >
                <b-table hover :items="tim_penguji" style="overflow: scroll;"></b-table>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Konfirmasi"
        :before-change="validationFormAddress"
        v-if="(berkas.role == 'pembimbing' || berkas.role == 'admin' || berkas.role == 'umum' || berkas.role == 'dekanat')"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
            <center style="margin-top: 70px;">
              Periksa kembali dan pastikan data dan berkas sudah sesuai untuk diproses.
            </center>
            <div class="d-flex justify-content-center" v-if="(berkas.role == 'pembimbing' || berkas.role == 'admin' || berkas.role == 'umum' || berkas.role == 'dekanat')" style="margin-top: 20px; margin-bottom: 100px;">
              <div class="mr-1" v-if="berkas.is_ok_umum == 'ya'">
                <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju  
              </b-button>
                <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
                  <center>
                    <label>Nomor Surat Nota Dinas</label>
                    <b-form-input
                    id="nomor_surat"
                    v-model="berkas.nomor_surat"
                    placeholder="Contoh : ND-96/UN2.F8.Prodi Sarjana/PDP.04.04/2024"
                  />
                  </center>
                  <br>
                  <center><p>Lengkapi nomor surat nota dinas dan klik ya untuk menetapkan jadwal sidang</p></center>
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)" :disabled="berkas.nomor_surat == null || showSpinner == 1"><span v-if="showSpinner == 0">Ya</span>
                        <b-spinner
                          v-if="showSpinner == 1"
                          :variant="'dark'"
                          size="sm"
                        ></b-spinner>
                      </b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
                  </div>
                </b-modal>
              </div>
              <div class="mr-1" v-else>
                <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
                <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Apakah anda setuju untuk menerima berkas ini?</p></center>
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)" :disabled="showSpinner == 1"><span v-if="showSpinner == 0">Ya</span>
                        <b-spinner
                          v-if="showSpinner == 1"
                          :variant="'dark'"
                          size="sm"
                        ></b-spinner>
                      </b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
                  </div>
                </b-modal>
              </div>

              <div>
                <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tidak Setuju</b-button>
                <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Berikan catatan penolakan</p></center>
                  <b-form-textarea
                    placeholder="Catatan penolakan"
                    v-model="catatanPenolakan"
                  />
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)" :disabled="showSpinner == 1"><span v-if="showSpinner == 0">Kirim</span>
                        <b-spinner
                          v-if="showSpinner == 1"
                          :variant="'dark'"
                          size="sm"
                        ></b-spinner>
                      </b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
                  </div>
                </b-modal>
              </div>
            </div>

            <div class="d-flex justify-content-center" v-if="berkas.role == 'superadmin' && berkas.status_sidang_id == 2">
              <div class="mr-1">
                <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
                <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Apakah anda ya yakin ingin menerima berkas ini?</p></center>
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)" :disabled="showSpinner == 1"><span v-if="showSpinner == 0">Ya</span>
                        <b-spinner
                        v-if="showSpinner == 1"
                          :variant="'dark'"
                          size="sm"
                        ></b-spinner>
                      </b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
                  </div>
                </b-modal>
              </div>

              <div>
                <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tidak Setuju</b-button>
                <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Berikan catatan perbaikan</p></center>
                  <b-form-textarea
                    placeholder="Catatan Perbaikan"
                    v-model="catatanPenolakan"
                  />
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)" :disabled="showSpinner == 1"><span v-if="showSpinner == 0">Kirim</span>
                        <b-spinner
                          v-if="showSpinner == 1"
                          :variant="'dark'"
                          size="sm"
                        ></b-spinner>
                      </b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
                  </div>
                </b-modal>
              </div>
            </div>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        v-if="berkas.role == 'umum'"
        title="Penetapan Jadwal Sidang"
        :before-change="validationFormAddress2"
      >
        <validation-observer
          ref="addressRules2"
          tag="form"
        >
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ruangan Terpakai
              </h5>
              <small class="text-muted">Daftar ruangan yang telah terpakai ujian</small>
            </b-col>
          </b-row>
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col md="12" class="mb-3" style="height: 200px;">
                <b-table hover :items="ruangan_terpakai" style="overflow: scroll;"></b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Ruangan Sidang"
                label-for="Ruangan Sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ruangan_sidang"
                  :rules="$can('set-ruangan-sidang','pengajuan-sidang') ? 'required' : ''"
                >
                  <v-select
                    id="ruangan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="ruanganOption.options"
                    v-model="jadwal_sidang.ruangan_id"
                    placeholder="Pilih Ruangan"
                    :disabled="!$can('set-ruangan-sidang','pengajuan-sidang')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Tanggal Ujian"
                label-for="Tanggal Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_ujian"
                  rules="required"
                >
                  <v-select
                    id="tanggal_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="tanggalUjianPenetapanOption.options"
                    v-model="jadwal_sidang.tanggal"
                    placeholder="Pilih Tanggal"
                    :disabled="!$can('manage','all-content') || berkas.is_ok_umum != null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Waktu Ujian"
                label-for="Waktu Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="waktu_ujian"
                  rules="required"
                >
                  <v-select
                    id="waktu_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="waktuUjianPenetapanOption.options"
                    v-model="jadwal_sidang.waktu_ujian_id"
                    placeholder="Pilih Waktu Ujian"
                    :disabled="!$can('manage','all-content') || berkas.is_ok_umum != null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div v-if="this.error_check.length == 0">
            <div class="d-flex justify-content-center mt-2">
              <b-spinner
              :variant="'dark'"
              ></b-spinner>
            </div>
            <div class="d-flex justify-content-center mt-2">
            Loading....
            </div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-center mt-2">
              <h4 style="color:red;">Gagal Memuat Data</h4>
            </div>
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
        <b-modal id="modal-center-reminder" centered title="Reminder" hide-footer no-close-on-backdrop no-close-on-esc>
          <center><feather-icon icon="AlertCircleIcon" style="height: 50px; width: 50px; color: gold;"/></center>
          <div class="d-flex justify-content-center mt-2">
              <h4 style="color:rgba(8, 8, 8, 0.925); text-align: center;">Mohon untuk menghubungi pembimbing dan mengingatkan pembimbing bahwa anda telah mendaftar sidang</h4>
          </div>
        </b-modal>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import JadwalSidangDosen from '@/views/pages/jadwal-sidang-dosen/list/List.vue'
import flatPickr from 'vue-flatpickr-component'
import "flatpickr/dist/flatpickr.min.css";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCalendar,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BFormTextarea,
  BModal,
  BSpinner,
  BTooltip,
  BTable,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { codeIcon } from './code'
import {
  getUserDetail,
  getJurusan,
  getJenjang,
  getProdi,
  getPeminatan,
  getJenisSidang,
  getProsesPersidangan,
  getDosen,
  postBerkas,
  updateBerkas,
  getPengajuanSidangDetail,
  uploadFilePengajuan,
  downloadDokumen,
  getRuangan,
  getProgram,
  getWaktuUjian,
  getJawabanPersetujuan,
  postWaktuUjian,
  deleteWaktuUjian,
  postPembimbing,
  deletePembimbing,
  postPenguji,
  deletePenguji,
  simpanNoteBerkas,
  postTerimaBerkas,
  postTolakBerkas,
} from '@/connection-api/master'
import SarjanaForm from '@/views/pages/pengajuan-sidang-readonly/SarjanaForm.vue'
import MagisterForm from '@/views/pages/pengajuan-sidang-readonly/MagisterForm.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    BButton,
    BCalendar,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BFormTextarea,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BModal,
    BSpinner,
    BTooltip,
    BTable,
    JadwalSidangDosen,
    flatPickr,
    SarjanaForm,
    MagisterForm,
    // ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
      // 15th two months prior
      const minDate = new Date('2023-06-12')
      minDate.setDate(minDate.getDate())
      // 15th in two months
      const maxDate = new Date('2023-07-12')
      maxDate.setDate(maxDate.getDate())

    return {
      masterData: {},
      counter: 0,
      flatpickrConfig: {
        enableTime: false, // Adjust as needed
        dateFormat: "d-m-Y",
        disable: [], // Example of specific date disable
        locale: Indonesian,
        timeZone: "Asia/Jakarta",
      },
      flatpickrConfigTanggalUjian: {
        enableTime: false, // Adjust as needed
        dateFormat: "d-m-Y",
        disable: [],
        locale: Indonesian,
        timeZone: "Asia/Jakarta",
      },
      params_jadwal_dosen: {},
      jadwalDosen: [
          { nama_dosen: 'Dickerson', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' },
          { nama_dosen: 'Larsen', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' },
          { nama_dosen: 'Geneva', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' },
          { nama_dosen: 'Jami', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' }
      ],
      catatanPenolakan: null,
      showSpinner: 0,
      showSpinnerPembimbing: 0,
      showSpinnerPenguji: 0,
      success_check: [],
      error_check: [],
      tahunOptions: [],
      showModal: 1,
      file: {
        file_persetujuan_pembimbing: null,
        file_ringkasan_turnitin: null,
        file_riwayat_pembayaran_bop: null,
        file_berkas_lengkap_skripsi: null,
        file_screenshoot_siak_ng: null,
      },
      minTime: '08:00',
      maxTime: '16:00',
      min: minDate,
      max: maxDate,
      selectedContry: '',
      selectedLanguage: '',
      userData: {},
      berkas: {},
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
       programOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Program --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Peminatan --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Sidang --' },
        ],
      },
      prosesPersidanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Skema Ujian --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      dosenUtamaOption: {
        selected: 'id',
        options: [
          { value: null, title: 'Pilih' },
          { value: 'ya', title: 'Ya' },
          { value: "tidak", title: 'Tidak' },
        ],
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu --' },
        ],
      },
      jawabanPersetujuanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jawaban --' },
        ],
      },
      jurusanSMAOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan SMA --' },
          { value: 'IPA', title: 'IPA' },
          { value: 'IPS', title: 'IPS' },
          { value: 'Lainnya', title: 'Lainnya' },
        ],
      },
      semesterOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Semester --' },
          { value: 'Ganjil', title: 'Ganjil' },
          { value: 'Genap', title: 'Genap' },
        ],
      },
      waktuUjianPenetapanOption: {
        selected: 'uuid',
        options: [],
      },
      jadwal_sidang: {},
      tanggalUjianPenetapanOption: {
        selected: 'uuid',
        options: [],
      },
      ruangan_terpakai: [
        {ruangan: 'Tidak ditemukan ruangan terpakai'}
      ],
      jenisPenelitianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Penelitian --' },
        ],
      },
    }
  },
  mounted() {
      this.disableDate()
      this.populateYearOptions();
      this.$bvModal.show('modal-center-loading')
      if(!this.$route.params.uuid){
          postBerkas()
          .then(response => {
            if (response.data.success == true) {
              success_check.push('success')
              this.completeCheck()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Sidang',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Redirecting ...',
                },
              })
              setTimeout(() => {
                this.$router.push({ 
                  name: 'pengajuan-sidang-edit', 
                  params: { uuid: response.data.data.uuid } 
                })
              }, 1000);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Sidang',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
                duration: 5000,
              })
            }
          })
          .catch(error => console.log(error));
        } else {
          this.reloadData()
        }
  },
  methods: {
    buildArray(data) {
      data.forEach(element => {
        this.ruangan_terpakai.push({
          nama: element.nama,
          judul: element.judul,
          ruangan: element.ruangan,
          tanggal: element.tanggal,
          waktu_ujian: element.waktu_ujian,
        })
      })
    },
    terimaBerkas(role)
    {
      this.showSpinner = 1
      var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
        nomor_surat: this.berkas.nomor_surat,
      }
      postTerimaBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.showModal = 0
          this.showSpinner = 0
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          this.showModal = 0
          this.showSpinner = 0
        }
      })
      .catch(error => {
        this.showModal = 0
        this.showSpinner = 0
      });
    },
    tolakBerkas(role)
    {
      this.showSpinner = 1
       var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTolakBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.showModal = 0
          this.showSpinner = 0
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          this.showModal = 0
          this.showSpinner = 0
        }
      })
      .catch(error => {
        this.showModal = 0
      });
    },
    simpanNote(uuid, note) {
      var data = {
        uuid: uuid,
        note: note,
      }
      simpanNoteBerkas(data)
      .then(response => {
          if(response.data.success == true)
          {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'success',
                text: 'Data berhasil disimpan',
              },
            })
            this.$root.$emit('bv::hide::modal', `bv-modal-note${uuid}`, '#btnShow')
          }
        })
      .catch(error => {
        this.error_check.push(error)
      });
    },
    disableDate() {
      const getCurrentFormattedDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const calculateFutureDatesExcludingWeekends = (startDateStr, daysToAdd) => {
        const parts = startDateStr.split('-');
        const startDate = new Date(parts[2], parts[1] - 1, parts[0]);
        const dates = [];
        let addedDays = 0;
        let currentDate = startDate;

        while (addedDays < daysToAdd) {
          currentDate.setDate(currentDate.getDate() + 1);
          const dayOfWeek = currentDate.getDay();
          if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Exclude Sundays (0) and Saturdays (6)
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = currentDate.getFullYear();
            dates.push(`${day}-${month}-${year}`);
            addedDays++;
          }
        }
        return dates;
      };

      const calculateWeekendsOfMonth = (month, year) => {
        const dates = [];
        const date = new Date(year, month, 1);
        while (date.getMonth() === month) {
          const dayOfWeek = date.getDay();
          if (dayOfWeek === 0 || dayOfWeek === 6) { // Include only Sundays (0) and Saturdays (6)
            const day = String(date.getDate()).padStart(2, '0');
            const monthStr = String(date.getMonth() + 1).padStart(2, '0');
            const yearStr = date.getFullYear();
            dates.push(`${day}-${monthStr}-${yearStr}`);
          }
          date.setDate(date.getDate() + 1);
        }
        return dates;
      };

      const calculateDatesFromStartOfMonthToToday = (todayDateStr) => {
        const parts = todayDateStr.split('-');
        const today = new Date(parts[2], parts[1] - 1, parts[0]);
        const dates = [];
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        let currentDate = startOfMonth;
        while (currentDate <= today) {
          const day = String(currentDate.getDate()).padStart(2, '0');
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const year = currentDate.getFullYear();
          dates.push(`${day}-${month}-${year}`);
          currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
      };

      // const today = new Date();
      // const startDateStr = getCurrentFormattedDate();
      // const todayDateStr = startDateStr;

      // const datesFromStartOfMonthToToday = calculateDatesFromStartOfMonthToToday(todayDateStr);
      // const next10BusinessDays = calculateFutureDatesExcludingWeekends(startDateStr, 8);
      // const weekendsOfCurrentMonth = calculateWeekendsOfMonth(today.getMonth(), today.getFullYear());
      // const allDatesToDisable = [...datesFromStartOfMonthToToday, ...weekendsOfCurrentMonth, ...next10BusinessDays];

      // this.flatpickrConfigTanggalUjian.disable = allDatesToDisable;
    },


    changeJenjang(val) {
      // Your method logic here
      this.berkas.prodi_id = null
      getProdi(val)
      .then(response => {
            this.prodiOption = {
            selected: 'id',
            options: [
              { value: null, title: '--Pilih Prodi --' },
            ],
          }
          var dataResponse = response.data
          this.buildOption(dataResponse, this.prodiOption)
      })
      .catch(error => {
        this.error_check.push(error)
      });
      
    },
    reloadData(val) {
      getPengajuanSidangDetail(this.$route.params.uuid, val)
            .then(response => {
              this.berkas = response.data.data;
              
              this.jadwal_sidang = this.berkas.jadwal_sidang
              if(this.jadwal_sidang.tanggal == '1970-01-01')
              {
                this.jadwal_sidang.tanggal = null
              }
              this.success_check.push('success')
              this.completeCheck()
              // if(this.berkas.status_pengajuan_sidang_id == '2dcb20fca8d7dabd6' || this.berkas.status_pengajuan_sidang_id == 'ae7ebb35d51267ce' || this.berkas.status_pengajuan_sidang_id == 'd790e33d3590f10799')
              // {
              //   this.$router.push({name: 'list-sidang'})
              // }
              
              if(this.berkas.jawaban.length > 0)
              {
                this.jawabanPersetujuanOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.jawaban, this.jawabanPersetujuanOption)
                this.masterData.jawaban = this.jawabanPersetujuanOption
              }

              if(this.berkas.jenis_penelitian.length > 0)
              {
                this.jenisPenelitianOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.jenis_penelitian, this.jenisPenelitianOption)
                this.masterData.jenis_penelitian = this.jenisPenelitianOption
              }

              if(this.berkas.ruangan.length > 0)
              {
                this.ruanganOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.ruangan, this.ruanganOption)
                this.masterData.ruangan = this.ruanganOption
              }

              if(this.berkas.dosen.length > 0)
              {
                this.dosenOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.dosen, this.dosenOption)
                this.masterData.dosen = this.dosenOption
              }

              if(this.berkas.waktu.length > 0)
              {
                this.waktuUjianOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.waktu, this.waktuUjianOption)
                this.masterData.waktu = this.waktuUjianOption
              }

              if(this.berkas.jurusan.length > 0)
              {
                this.jurusanOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.jurusan, this.jurusanOption)
                this.masterData.jurusan = this.jurusanOption
              }

              if(this.berkas.proses_persidangan.length > 0)
              {
                this.prosesPersidanganOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.proses_persidangan, this.prosesPersidanganOption)
                this.masterData.proses_persidangan = this.prosesPersidanganOption
              }

              if(this.berkas.jenis_sidang.length > 0)
              {
                this.jenisSidangOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.jenis_sidang, this.jenisSidangOption)
                this.masterData.jenis_sidang = this.jenisSidangOption
              }

              if(this.berkas.jenjang.length > 0)
              {
                this.jenjangOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.jenjang, this.jenjangOption)
                this.masterData.jenjang = this.jenjangOption
              }

              if(this.berkas.prodi.length > 0)
              {
                this.prodiOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.prodi, this.prodiOption)
                this.masterData.prodi = this.prodiOption
              }

              if(this.berkas.peminatan.length > 0)
              {
                this.peminatanOption = {
                  selected: 'id',
                  options: [
                    { value: null, title: '--Pilih--' },
                  ],
                }
                this.buildOption(this.berkas.peminatan, this.peminatanOption)
                this.masterData.peminatan = this.peminatanOption
              }

              if(this.berkas.waktu_ujian_penetapan.length > 0)
              {
                this.waktuUjianPenetapanOption = {
                  selected: 'uuid',
                  options: [{ value: null, title: '--Pilih--' },],
                }
                this.buildOption(this.berkas.waktu_ujian_penetapan, this.waktuUjianPenetapanOption)
              }

              if(this.berkas.tanggal_ujian_penetapan.length > 0)
              {
                this.tanggalUjianPenetapanOption = {
                  selected: 'uuid',
                  options: [{ value: null, title: '--Pilih--' },],
                }
                this.buildOption(this.berkas.tanggal_ujian_penetapan, this.tanggalUjianPenetapanOption)
              }

              if(this.berkas.ruangan_terpakai.length > 0)
              {
                this.ruangan_terpakai = []
                this.buildArray(this.berkas.ruangan_terpakai)
              }
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    reloadDataWaktuUjian() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas.waktu_ujian = response.data.data.waktu_ujian;
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    reloadDataPembimbing() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas.dosen_pembimbing = response.data.data.dosen_pembimbing;
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    reloadDataPenguji() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas.dosen_penguji = response.data.data.dosen_penguji;
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    async tambahWaktuUjian() {
      this.showSpinner = 1
      var data = {
        uuid: this.$route.params.uuid,
        waktu_ujian: this.berkas.waktu_ujian,
        jenjang_id: this.berkas.jenjang_id,
      }
      await postWaktuUjian(data)
            .then(response => {
              if (response.data.success == true) {
                this.reloadDataWaktuUjian()
                this.showSpinner = 0
              } else {
                this.showSpinner = 0
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
    },
    async deleteWaktuUjian(uuid) {
      this.showSpinner = 1
      var data = {
        pengajuan_sidang_uuid: this.$route.params.uuid,
        uuid: uuid,
      }
      await deleteWaktuUjian(data)
        .then(response => {
          if (response.data.success == true) {
            this.reloadDataWaktuUjian()
            this.showSpinner = 0
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
    },
    async tambahPembimbing() {
      this.showSpinnerPembimbing = 1
      var data = {
        uuid: this.$route.params.uuid,
        jenjang_id: this.berkas.jenjang_id,
        dosen_pembimbing: this.berkas.dosen_pembimbing,
      }
      await postPembimbing(data)
            .then(response => {
              if (response.data.success == true) {
                this.reloadDataPembimbing()
                this.showSpinnerPembimbing = 0
              } else {
                this.showSpinnerPembimbing = 0
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
    },
    async deletePembimbing(uuid) {
      this.showSpinnerPembimbing = 1
      var data = {
        pengajuan_sidang_uuid: this.$route.params.uuid,
        uuid: uuid,
      }
      await deletePembimbing(data)
        .then(response => {
          if (response.data.success == true) {
            this.reloadDataPembimbing()
            this.showSpinnerPembimbing = 0
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
    },
    async tambahPenguji() {
      this.showSpinnerPenguji = 1
      var data = {
        uuid: this.$route.params.uuid,
        jenjang_id: this.berkas.jenjang_id,
        dosen_penguji: this.berkas.dosen_penguji,
      }
      await postPenguji(data)
            .then(response => {
              if (response.data.success == true) {
                this.reloadDataPenguji()
                this.showSpinnerPenguji = 0
              } else {
                this.showSpinnerPenguji = 0
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
    },
    async deletePenguji(uuid) {
      this.showSpinnerPenguji = 1
      var data = {
        pengajuan_sidang_uuid: this.$route.params.uuid,
        uuid: uuid,
      }
      await deletePenguji(data)
        .then(response => {
          if (response.data.success == true) {
            this.reloadDataPenguji()
            this.showSpinnerPenguji = 0
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
    },
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    populateYearOptions() {
      const currentYear = new Date().getFullYear();
      const yearsToShow = 30; // Adjust this number as needed to show more or fewer years

      for (let i = currentYear; i >= currentYear - yearsToShow; i--) {
        this.tahunOptions.push({ value: i, title: i.toString() });
      }
    },
    completeCheck()
    {
      if(this.success_check.length > 0 && this.error_check.length == 0)
      {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    async downloadFile(file){
      const result = await downloadDokumen(file);
      const blob = new Blob([result.data], {type: 'application/vnd.ms-powerpoint'});
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      const date = new Date().toLocaleString(['ban', 'id']);
      const filename = `berkas-${date}.pptx`.replace(/[^a-z0-9_.-]/gi, '_'); // replaces invalid characters
      link.download = filename;
      link.href = url;

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url)
    },
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadDokumen(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pengajuan Sidang',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      // return weekday === 0 || weekday === 6 || day === 14
        return weekday === 0
    },
    formSubmitted() {
      if(window.confirm('Apakah anda yakin ingin kembali ke menu daftar sidang?'))
      {
        this.$router.push({name: 'list-sidang'})
        // this.$bvModal.show('modal-center-loading')
        // this.showModal = 1
        //  this.berkas.flag = 'Konfirmasi'
        //   uploadFilePengajuan(this.berkas.file_presentasi, 'user', event => {
        //     this.progress = Math.round((100 * event.loaded) / event.total)
        //   })
        //     .then(response => {
        //       this.berkas.berkas_presentasi = response.data.data;

        //       updateBerkas(this.berkas)
        //       .then(response => {
        //         if (response.data.success == true) {
        //           this.$toast({
        //             component: ToastificationContent,
        //             props: {
        //               title: 'Pengajuan Sidang',
        //               icon: 'EditIcon',
        //               variant: 'success',
        //               text: 'Data berhasil disimpan',
        //             },
        //             duration: 5000,
        //           })
        //           this.showModal = 0
        //           if(this.berkas.role == 'mahasiswa')
        //           {
        //             this.$bvModal.show('modal-center-reminder')
        //              setTimeout(() => {
        //               this.$router.push({name: 'list-sidang'})
        //             }, 5000);
        //           }
        //         } else {
        //           this.$toast({
        //             component: ToastificationContent,
        //             props: {
        //               title: 'Pengajuan Sidang',
        //               icon: 'EditIcon',
        //               variant: 'danger',
        //               text: response.data.message,
        //             },
        //           })
        //           this.showModal = 0
        //         }
        //       })
        //       .catch(error => {
        //         this.showModal = 0
        //       });
        //     })
        //   .catch(error => {
        //     this.showModal = 0
        //   });
      }
    },
    kapitalDiAwalKata(value) {
      // Memisahkan kalimat menjadi array kata
      var kataArray = value.split(' ');

      // Mengonversi huruf pertama setiap kata menjadi kapital
      for (var i = 0; i < kataArray.length; i++) {
        kataArray[i] = kataArray[i].charAt(0).toUpperCase() + kataArray[i].slice(1);
      }

      // Menggabungkan kembali array kata menjadi kalimat
      var kalimatBaru = kataArray.join(' ');

      return kalimatBaru;
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            this.berkas.flag = 'Jenis Sidang'
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormPendaftaran() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRulesPendaftaran.validate().then(success => {
          if (success) {
            if(this.berkas.role == 'mahasiswa')
            {
              resolve(true)
            } else {
              this.berkas.flag = 'Biodata'
              this.berkas.judul = this.kapitalDiAwalKata(this.berkas.judul)
              updateBerkas(this.berkas)
              .then(response => {
                if (response.data.success == true) {
                  this.berkas.berkas_pengajuan = response.data.data
                  resolve(true)
                } else {
                  reject()
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Pengajuan Sidang',
                      icon: 'EditIcon',
                      variant: 'danger',
                      text: response.data.message,
                    },
                  })
                }
              })
              .catch(error => console.log(error));
            }
          } else {
            reject()
          }
        })
      })
    },
    simpanBerkas(){
      this.showSpinner = 1
      this.berkas.berkas_pengajuan.forEach(function(value, index, data) {
        // Code to execute for each element in the array
        if(data[index].file_input != null)
        {
          uploadFilePengajuan(data[index].file_input, 'user', event => {
          var progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response0 => {
            data[index].file = response0.data.data
            data[index].flag = 'Berkas Sidang'
            updateBerkas(data[index])
            .then(response => {
            })
            .catch(error => console.log(error));
          })
        .catch(error => console.log(error));
        }
      });

      this.berkas.berkas_pengajuan.forEach(function(value, index, data) {
        // Code to execute for each element in the array
        if(data[index].file_input != null)
        {
          data[index].file_input = null
        }
      })

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Pengajuan Sidang',
          icon: 'EditIcon',
          variant: 'success',
          text: 'Data Berhasil Disimpan',
        },
      })
      this.showSpinner = 0
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            this.$bvModal.show('modal-center-loading')
            this.showModal = 1
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress2() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules2.validate().then(success => {
          if (success) {
            this.berkas.flag = 'jadwal-sidang'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                resolve(true)
              } else {
                reject()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => console.log(error));
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress3() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules3.validate().then(success => {
          if (success) {
            this.berkas.flag = 'surat-tugas'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                resolve(true)
              } else {
                reject()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => console.log(error));
            // resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
